import React, { useEffect } from 'react';

import { useAppDispatch } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import NavRoutes from '~navigation/Routes';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import config from '~config';
import packageJson from '../package.json';

import './App.scss';

dayjs.extend(utc);

const App = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(combinedActions.authStartupAttempt());

        if (config.env === 'dev' || config.env === 'sit') {
            console.log(`${config.env} v${packageJson.version}`);
        }
    }, []);

    return (
        <div className='app-container'>
            <NavRoutes />
        </div>
    );
};

export default App;
